<template>
    <div class="skeleton-loader">
        <row class="h-full">
            <client-only>
                <column :cols="currentSkeletonCols" v-for="skeletonColId in amountOfColumns" :key="skeletonColId">
                    <template v-for="(skeletonId, skeletonIdIndex) in amountOfSkeletonsPerColumn" :key="skeletonColId + '-' + skeletonIdIndex">
                        <lazy-resource-list-item-skeleton v-if="template === 'resourceListItem'"/>
                        <lazy-checkbox-skeleton v-else-if="template === 'checkbox'"/>
                        <lazy-paragraph-skeleton v-else-if="template === 'paragraph'"/>
                        <lazy-image-skeleton v-else/>
                    </template>
                </column>
            </client-only>
        </row>
    </div>
</template>

<script>
import DisplaysSkeletonMixin from "./DisplaysSkeletonMixin";

    export default {
        name: "SkeletonLoader",

        mixins: [DisplaysSkeletonMixin],

        computed: {

            template() {
                if (this.skeleton) {
                    return this.skeleton.split('@')[0];
                }

                return this.skeleton;
            },

            amountOfSkeletons() {
                let baseSkeleton = this.skeleton.split('@');
                if (baseSkeleton.length > 1) {
                    return parseInt(baseSkeleton[1])
                }

                return 1;
            },

            currentSkeletonCols() {
                if (this.$breakpoint.xlOnly && this.skeletonColsXl) {
                    return this.skeletonColsXl;
                }
                if (this.$breakpoint.lgAndUp && this.skeletonColsLg) {
                    return this.skeletonColsLg;
                }
                if (this.$breakpoint.mdAndUp && this.skeletonColsMd) {
                    return this.skeletonColsMd;
                }
                if (this.$breakpoint.smAndUp && this.skeletonColsSm) {
                    return this.skeletonColsSm;
                }

                return this.skeletonCols;
            },

            // Necessary to show dividers on skeletons
            amountOfColumns() {
                return this.currentSkeletonCols === 12 ? 1 : this.amountOfSkeletons
            },

            amountOfSkeletonsPerColumn() {
                return this.amountOfColumns === 1 ? this.amountOfSkeletons : 1
            }

        },
    }
</script>

<style>
.skeleton-loader {
  border-radius: inherit;
}
</style>